import { breakpointXl } from '@ingka/variables';

export const breakpoints = {
  portraitPhoneUp: 320,
  landscapePhoneUp: 600,
  portraitTabletUp: 768,
  desktopUp: 1024,
  desktopLargeUp: 1500,
};

export const mediaQueries = {
  portraitPhoneUp: `@media (min-width: ${breakpoints.portraitPhoneUp}px)`,
  landscapePhoneUp: `@media (min-width: ${breakpoints.landscapePhoneUp}px)`,
  portraitTabletUp: `@media (min-width: ${breakpoints.portraitTabletUp}px)`,
  desktopUp: `@media (min-width: ${breakpoints.desktopUp}px)`,
  desktopLargeUp: `@media (min-width: ${breakpoints.desktopLargeUp}px)`,
  portraitXl: `@media (min-width: ${breakpointXl}) and (orientation: portrait)`,
  landscapeXl: `@media (min-width: ${breakpointXl}) and (orientation: landscape)`,
};
